document.addEventListener('DOMContentLoaded', function () {
    // Initialisiert die Variantenauswahl für jedes Produkt
    function initVariantSelector(variantSelector) {
        const productId = variantSelector.dataset.productId;
        const initialVariantId = variantSelector.dataset.initialVariant;
        const productCard = variantSelector.closest('.product-card');
        const mainImage = productCard.querySelector('.product-card__image--primary');
        const productLink = productCard.querySelector('a.product-card__media');
        const options = window[`productOptions_${productId}`];
        const optionSelectors = options.map(option => ({
            name: option.name,
            elements: variantSelector.querySelectorAll(`.${option.name.toLowerCase().replace(/\s+/g, '-')}-options .option-item:not(.more-options)`)
        }));
        const moreOptionsButtons = variantSelector.querySelectorAll('.more-options');

        // Aktualisiert das Hauptbild basierend auf der ausgewählten Variante
        function updateMainImage(variant) {
            if (variant && variant.featured_image) {
                const imageContainer = mainImage.closest('.product-card__media');
                const variantImages = window[`variantImages_${productId}`];
                const scaledImage = variantImages[variant.id];

                // Füge die Klasse 'loading' hinzu
                imageContainer.classList.add('loading');

                // Blendet das aktuelle Bild aus
                mainImage.style.opacity = '0';

                // Verwendet das vorskalierte Bild wenn verfügbar
                if (scaledImage) {
                    mainImage.src = scaledImage;
                    // Entfernt srcset da wir bereits die optimale Größe haben
                    mainImage.removeAttribute('srcset');
                } else {
                    // Fallback auf original Variante
                    mainImage.src = variant.featured_image.src;
                    if (variant.featured_image.srcset) {
                        mainImage.srcset = variant.featured_image.srcset;
                    } else {
                        mainImage.removeAttribute('srcset');
                    }
                }

                if (variant.featured_image.alt) {
                    mainImage.alt = variant.featured_image.alt;
                }

                // Event-Handler für das Laden des Bildes
                const imageLoadHandler = function () {
                    // Entfernt die Klasse 'loading'
                    imageContainer.classList.remove('loading');

                    // Blendet das neue Bild ein
                    mainImage.style.opacity = '1';

                    // Entfernt den Event-Listener
                    mainImage.removeEventListener('load', imageLoadHandler);
                };

                // Fügt den Event-Listener hinzu
                mainImage.addEventListener('load', imageLoadHandler);

                // Fehlerbehandlung
                mainImage.addEventListener('error', function errorHandler() {
                    // Entfernt die Klasse 'loading' bei Fehler
                    imageContainer.classList.remove('loading');
                    mainImage.style.opacity = '1';

                    // Entfernt den Error-Listener
                    mainImage.removeEventListener('error', errorHandler);
                });
            }
        }

        // Aktualisiert den Produktlink mit der Variantenauswahl
        function updateProductLink(variant) {
            if (variant && productLink) {
                const currentUrl = new URL(productLink.href);
                currentUrl.searchParams.set('variant', variant.id);
                productLink.href = currentUrl.toString();
            }
        }

        // Aktualisiert die aktive Klasse bei Optionen
        function updateActiveClass(options, clickedOption) {
            options.forEach(option => option.classList.remove('active'));
            clickedOption.classList.add('active');
        }

        // Findet die Variante basierend auf den ausgewählten Optionen und aktualisiert das Bild und den Link
        function findVariantAndUpdate(selectedOptions) {
            const variant = window[`productVariants_${productId}`].find(v =>
                options.every((option, index) => v[`option${index + 1}`] === selectedOptions[option.name])
            );

            if (variant) {
                updateMainImage(variant);
                updateProductLink(variant);
                return true;
            }
            return false;
        }

        // Handhabung des Klicks auf eine Option
        function handleOptionClick(clickedOption, optionIndex) {
            const selectedValue = clickedOption.dataset.value;
            updateActiveClass(optionSelectors[optionIndex].elements, clickedOption);

            if (options.length > 1 && optionIndex === 0) {
                const secondOptionSelector = optionSelectors[1];
                const currentActiveSecondOption = Array.from(secondOptionSelector.elements).find(el => el.classList.contains('active'));
                const currentSecondOptionValue = currentActiveSecondOption ? currentActiveSecondOption.dataset.value : null;

                updateSecondOptionVisibility(selectedValue);

                // Beibehaltung der aktuellen Auswahl, falls verfügbar
                let newActiveSecondOption = Array.from(secondOptionSelector.elements).find(option =>
                    !option.classList.contains('hidden') && option.dataset.value === currentSecondOptionValue
                );

                // Auswahl der ersten sichtbaren Option, falls notwendig
                if (!newActiveSecondOption) {
                    newActiveSecondOption = Array.from(secondOptionSelector.elements).find(option => !option.classList.contains('hidden'));
                }

                if (newActiveSecondOption) {
                    updateActiveClass(secondOptionSelector.elements, newActiveSecondOption);
                }
            }

            const selectedOptions = {};
            optionSelectors.forEach(selector => {
                const activeOption = variantSelector.querySelector(`.${selector.name.toLowerCase().replace(/\s+/g, '-')}-options .option-item.active`);
                if (activeOption) {
                    selectedOptions[selector.name] = activeOption.dataset.value;
                }
            });

            findVariantAndUpdate(selectedOptions);
        }

        // Aktualisiert die Sichtbarkeit der zweiten Optionsauswahl basierend auf der ersten Auswahl
        function updateSecondOptionVisibility(firstOptionValue) {
            if (optionSelectors.length < 2) return;

            const secondOptionSelector = optionSelectors[1];
            const moreOptionsButton = variantSelector.querySelector(`.${secondOptionSelector.name.toLowerCase().replace(/\s+/g, '-')}-options .more-options`);

            let visibleCount = 0;
            Array.from(secondOptionSelector.elements).forEach(option => {
                option.classList.remove('fade-in');
                if (option.dataset.option1 === firstOptionValue) {
                    visibleCount++;
                    option.classList.remove('hidden');
                    if (visibleCount <= 5) {
                        setTimeout(() => {
                            option.classList.add('fade-in');
                        }, 50 * visibleCount); // Gestaffelter Fade-in-Effekt
                    } else {
                        option.classList.add('hidden');
                    }
                } else {
                    option.classList.add('hidden');
                }
            });

            if (moreOptionsButton) {
                moreOptionsButton.classList.remove('fade-in');
                if (visibleCount > 5) {
                    moreOptionsButton.classList.remove('hidden');
                    moreOptionsButton.querySelector('span').textContent = `+${visibleCount - 5}`;
                    setTimeout(() => {
                        moreOptionsButton.classList.add('fade-in');
                    }, 50 * (visibleCount + 1)); // Fade-in nach allen sichtbaren Optionen
                } else {
                    moreOptionsButton.classList.add('hidden');
                }
            }
        }

        // Event-Listener für Optionen hinzufügen
        optionSelectors.forEach((selector, index) => {
            selector.elements.forEach(option => {
                option.addEventListener('click', function () {
                    handleOptionClick(this, index);
                });
            });
        });

        // Initiale Einrichtung
        const initialVariant = window[`productVariants_${productId}`].find(v => v.id == initialVariantId);
        if (initialVariant) {
            options.forEach((option, index) => {
                const activeOption = variantSelector.querySelector(`.${option.name.toLowerCase().replace(/\s+/g, '-')}-options .option-item[data-value="${initialVariant[`option${index + 1}`]}"]`);
                if (activeOption) {
                    updateActiveClass(optionSelectors[index].elements, activeOption);
                }
            });

            if (options.length > 1) {
                updateSecondOptionVisibility(initialVariant.option1);
            }

            updateMainImage(initialVariant);
            updateProductLink(initialVariant);
        }
    }

    // Initialisiert alle Variantenselektoren auf der Seite
    document.querySelectorAll('.variant-selector').forEach(initVariantSelector);
});